// Datos estructurados específicos de la home (movidos desde __root para evitar duplicados)
// Schema.org JSON-LD, preserved from the pre-migration index.html
// professionalServiceSchema movido a src/lib/site-schema.ts (localBusinessSchema) para evitar duplicados.

export const serviceListSchema = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: [
    {
      "@type": "Service",
      position: 1,
      name: "SEO Local con IA",
      description:
        "Optimización de posicionamiento local para negocios con inteligencia artificial",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "SEO Local",
    },
    {
      "@type": "Service",
      position: 2,
      name: "SEO Web con IA",
      description: "Posicionamiento web orgánico potenciado con inteligencia artificial",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "SEO Web",
    },
    {
      "@type": "Service",
      position: 3,
      name: "SEO para Ecommerce con IA",
      description: "Optimización SEO especializada para tiendas online con IA",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "SEO Ecommerce",
    },
    {
      "@type": "Service",
      position: 4,
      name: "Link Building Inteligente",
      description:
        "Construcción de enlaces de calidad con estrategias de inteligencia artificial",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "Link Building",
    },
    {
      "@type": "Service",
      position: 5,
      name: "Publicidad SEM con IA",
      description:
        "Campañas de publicidad en buscadores optimizadas con inteligencia artificial",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "SEM",
    },
    {
      "@type": "Service",
      position: 6,
      name: "Desarrollo Web React",
      description: "Creación de aplicaciones web modernas con React y optimización SEO",
      provider: { "@type": "Organization", name: "SEOEVOLUTION" },
      areaServed: "España",
      serviceType: "Desarrollo Web",
    },
  ],
});

export const faqSchema = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "¿Cuánto tiempo tarda en funcionar el SEO?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "La evolución depende del estado inicial, la competencia y las decisiones de cada buscador. El calendario organiza tareas y revisiones, no garantiza resultados. SEO local tiene un mínimo de 3 meses y GEO de 6; la continuidad posterior es opcional y a convenir. Los plazos se evalúan según el proyecto.",
      },
    },
    {
      "@type": "Question",
      name: "¿Qué ventaja tiene una web en React frente a WordPress para el SEO?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "React permite construir webs con tiempos de carga por debajo de 1 segundo y Core Web Vitals en verde, factores que Google valora directamente en el ranking. WordPress bien optimizado puede competir, pero parte en desventaja técnica estructural. Además, las webs en React tienen menor coste de mantenimiento a largo plazo y se adaptan mejor a integraciones con herramientas de marketing digital.",
      },
    },
    {
      "@type": "Question",
      name: "¿Qué significa zona exclusiva territorial?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Cuando contratas SEOEVOLUTION para tu negocio, ningún competidor directo de tu misma zona geográfica y sector puede contratar el mismo servicio. La exclusividad se define por sector y zona, y está recogida en el contrato. Esto garantiza que todo el trabajo SEO que hacemos para tu empresa no va a beneficiar a tu competencia directa.",
      },
    },
    {
      "@type": "Question",
      name: "¿Qué diferencia hay entre SEO tradicional y SEO con IA?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "El SEO tradicional depende de análisis manuales y actualizaciones periódicas. El SEO con IA permite monitorizar cambios en tiempo real, detectar oportunidades de palabras clave automáticamente, optimizar contenidos basándose en el comportamiento real del usuario y anticipar cambios de algoritmo. El resultado es una estrategia más ágil, más precisa y con mejor ratio de resultados por euro invertido.",
      },
    },
    {
      "@type": "Question",
      name: "¿Puedo migrar mi web de WordPress a React sin perder posicionamiento?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sí, siempre que la migración se planifique correctamente. En SEOEVOLUTION realizamos migraciones técnicas con auditoría SEO previa, mapa completo de redirecciones 301, preservación de estructura de URLs cuando es posible, y monitorización intensiva durante los 60 días posteriores a la migración para detectar y corregir cualquier caída de tráfico.",
      },
    },
    {
      "@type": "Question",
      name: "¿Cuánto cuesta el SEO local para un negocio en España?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Depende de la competencia en la zona, el número de servicios a posicionar y si se incluye la gestión de Google Business Profile. En SEOEVOLUTION no publicamos tarifas: cada empresa necesita una estrategia propia, y diseñamos la visibilidad en Google Maps según tu mercado, competencia y objetivos. Alcance e inversión se concretan tras el diagnóstico.",
      },
    },
  ],
});
